'use client';

import ErrorBoundaryPage from '../Member/ErrorBoundaryPage';

/**
 * 개발환경에서 ErrorBoundaryPage를 보여주는 경우 error catch가 안되고 무한 리렌더링되는 현상 방지
 */
export default process.env.NODE_ENV === 'production' ? ErrorBoundaryPage : null;
